export default "__VITE_ASSET__nXk7fDuA__"